import { GetEmployeeHubDataMeta, GetEmployeeHubDataPayload } from 'types/store/GetEmployeeHubData';
import { createAsyncReducer } from 'utils/Redux';

import { getEmployeeHubDataActions } from '../actions';

export default createAsyncReducer<GetEmployeeHubDataMeta, GetEmployeeHubDataPayload>(getEmployeeHubDataActions);
